import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Cabservicenearmemumbai() {



const cardData = {
  keyword: " Cab Service Near Me Mumbai",

headingDescription:
  "Omshree Cab offers convenient and reliable cab service near me in Mumbai, perfect for travelers who want quick, safe, and comfortable transportation from their current location. Whether you need a cab for airport transfers, city commuting, local sightseeing, business travel, or family outings, our service ensures timely pickups with professional drivers and well‑maintained vehicles. We provide flexible booking options including one‑way rides, round trips, hourly rentals, and full‑day packages at transparent pricing. Our fleet includes air‑conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With easy online booking, punctual pickups from any address in Mumbai, and 24/7 customer support, Omshree Cab makes finding a dependable cab service near you quick and stress‑free.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is a famous Mumbai landmark overlooking the Arabian Sea and a must‑visit destination for tourists and locals alike. The historic monument was built during the British era and continues to attract visitors who enjoy photography, sightseeing, and boat rides to nearby Elephanta Island. The area around the Gateway features vibrant street markets, cafes, and heritage buildings. Using a nearby cab service makes reaching this iconic spot easy and comfortable without worrying about traffic or parking."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic seaside promenade along the Arabian Sea, popularly known as the Queen’s Necklace because of the line of streetlights that sparkle at night. It’s a favorite spot for evening walks, sunset views, and relaxation by the sea breeze. The long stretch of road is ideal for enjoying scenic drives and taking memorable photographs. With a cab service near you, travelers can easily explore Marine Drive and nearby attractions like Nariman Point and Chowpatty Beach without transport stress."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of Mumbai’s most popular beaches, attracting visitors throughout the year for its sandy shores, sea breeze, and delicious street food like pav bhaji, bhel puri, and pani puri. The beach comes alive during evenings and weekends when families and tourists gather to enjoy the sunset and seaside atmosphere. A nearby cab helps visitors reach the beach comfortably and conveniently from any part of the city."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is one of the most revered religious sites in Mumbai, dedicated to Lord Ganesha. Devotees and tourists visit the temple to seek blessings, participate in rituals, and experience the spiritual atmosphere. The temple attracts large crowds, especially during festivals like Ganesh Chaturthi. Using a cab service near you makes reaching the temple easy and avoids the challenges of parking and navigating busy city traffic."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "Bandra Worli Sea Link is a modern engineering marvel that connects Bandra and Worli across the Arabian Sea. The cable‑stayed bridge provides breathtaking views of the sea and city skyline, especially during sunset and at night when illuminated. Many travelers enjoy driving across the sea link for the scenic experience. With a cab service nearby, visitors can comfortably explore this landmark and continue to other destinations in the city."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a famous shrine located on a small island off the coast of Mumbai and accessible via a narrow walkway during low tide. The white marble structure and peaceful surroundings attract visitors from different communities. Pilgrims and tourists come to offer prayers, enjoy sea views, and experience the calm environment. A nearby cab service provides convenient transportation to this spiritual site."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock‑cut caves located on Elephanta Island, known for their impressive stone sculptures dedicated to Lord Shiva. This UNESCO World Heritage Site is a popular day‑trip destination from Mumbai. Visitors take a ferry from the Gateway of India to reach the island and explore the historic cave temples. A cab service near you makes it easy to reach the ferry terminal comfortably and begin the island trip with ease."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a vast forest reserve within Mumbai city that offers trekking, nature walks, wildlife spotting, and the ancient Kanheri Caves. Visitors enjoy a refreshing escape from city life and spend time exploring nature and historical sites. With a cab service near you, travelers can reach the park conveniently from different parts of Mumbai and plan a full day of outdoor activities."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a bustling shopping street in South Mumbai known for its lively markets, street stalls, and local eateries. Visitors can shop for clothes, accessories, jewelry, handicrafts, and souvenirs while experiencing the vibrant street culture. A nearby cab service ensures visitors can reach this busy market comfortably and integrate it into their sightseeing itinerary."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also called Pherozeshah Mehta Gardens, are terraced green gardens located on Malabar Hill offering panoramic views of Marine Drive and the Arabian Sea. Visitors come here for morning walks, relaxation, photography, and enjoying peaceful greenery in the heart of the city. With a nearby cab service, it is easy to reach this scenic spot and combine it with other nearby attractions on your Mumbai itinerary."
  }
],



services: [
{
name: "Cab Service Near Me Mumbai",
description: "Cab service near me in Mumbai helps passengers quickly find reliable transportation in their nearby location. Our fleet includes comfortable AC sedans and SUVs suitable for local and intercity travel. Professional drivers ensure punctual pickup and safe driving throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Mumbai. Ideal for daily commuting, airport transfers, and personal travel. Spacious interiors ensure comfortable seating during the trip. Flexible booking options allow quick ride confirmation. Reliable cab services ensure convenient travel anytime."
},
{
name: "Taxi Near Me Mumbai",
description: "Taxi near me in Mumbai provides convenient transportation for passengers searching for nearby taxi services. Our AC taxis ensure smooth travel through city roads and highways. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from residential areas, offices, hotels, and transport hubs across Mumbai. Ideal for urgent travel, daily commuting, and short-distance trips. Spacious seating ensures comfortable journeys for passengers. Flexible ride scheduling allows easy trip planning. Reliable taxi services ensure quick and dependable transportation."
},
{
name: "Cab Near Me Mumbai",
description: "Cab near me in Mumbai allows passengers to find nearby cab services for immediate transportation needs. Our fleet includes AC sedans and SUVs designed for comfortable city travel. Professional drivers ensure safe driving and timely pickup services. Pickup services are available across residential areas, offices, hotels, and railway stations in Mumbai. Ideal for business travel, tourism visits, and daily commuting. Spacious interiors ensure comfortable journeys for passengers. Flexible booking options allow quick ride scheduling. Reliable cab services ensure smooth transportation."
},
{
name: "Taxi Service Near Me Mumbai",
description: "Taxi service near me in Mumbai offers convenient transportation for passengers searching for nearby taxis. Our AC vehicles ensure smooth and comfortable travel across city roads. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available across Mumbai including homes, offices, hotels, and transport hubs. Ideal for business travel, tourism visits, and personal trips. Spacious seating ensures relaxed journeys during travel. Flexible booking options allow easy ride scheduling. Reliable taxi services ensure stress-free transportation."
},
{
name: "Nearest Cab Service Mumbai",
description: "Nearest cab service in Mumbai helps passengers quickly locate available vehicles nearby for convenient travel. Our fleet includes comfortable AC sedans and SUVs suitable for city transportation. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across residential areas, offices, hotels, and airport terminals in Mumbai. Ideal for urgent travel, daily commuting, and business visits. Spacious interiors ensure comfortable journeys for passengers. Flexible booking options allow instant ride confirmation. Reliable cab services ensure quick and efficient transportation."
},
{
name: "Nearest Taxi Booking Mumbai",
description: "Nearest taxi booking in Mumbai allows passengers to reserve taxis quickly from nearby locations. Our AC taxis ensure comfortable travel across city roads and highways. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across Mumbai including homes, offices, hotels, and railway stations. Ideal for daily commuting, airport transfers, and urgent travel. Spacious seating ensures comfortable journeys during the trip. Flexible booking options allow instant ride scheduling. Reliable taxi booking ensures convenient transportation."
},
{
name: "Cab Booking Near Me Mumbai",
description: "Cab booking near me in Mumbai offers quick reservations for passengers looking for nearby transportation. Our fleet includes AC sedans and SUVs suitable for comfortable travel across the city. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available across residential areas, offices, hotels, and airport terminals in Mumbai. Ideal for business travel, tourism visits, and personal trips. Spacious interiors ensure comfortable journeys for passengers. Flexible booking options allow easy ride confirmation. Reliable cab booking services ensure smooth transportation."
},
{
name: "Cheap Cab Near Me Mumbai",
description: "Cheap cab near me in Mumbai provides affordable transportation for passengers searching for budget-friendly rides nearby. Our fleet includes economical AC sedans suitable for comfortable city travel. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across homes, offices, hotels, and transport hubs in Mumbai. Ideal for students, daily commuters, and budget travelers. Comfortable interiors ensure relaxed journeys during travel. Flexible booking options allow convenient ride scheduling. Affordable cab services ensure economical transportation."
},
{
name: "Airport Cab Near Me Mumbai",
description: "Airport cab near me in Mumbai provides convenient transportation for passengers traveling to or from nearby airport terminals. Comfortable AC vehicles ensure smooth travel between airport and city locations. Professional drivers monitor flight timings to provide punctual pickup and drop services. Pickup services are available from homes, hotels, offices, and nearby areas across Mumbai. Ideal for business travelers, tourists, and family travel. Spacious interiors ensure comfortable airport journeys. Flexible booking options allow advance ride reservations. Reliable airport cab services ensure stress-free transportation."
}
],

tableData: [
["Cab Service Near Me Mumbai","Taxi Near Me Mumbai"],
["Cab Near Me Mumbai","Taxi Service Near Me Mumbai"],
["Nearest Cab Service Mumbai","Nearest Taxi Booking Mumbai"],
["Cab Booking Near Me Mumbai","Cheap Cab Near Me Mumbai"],
["Airport Cab Near Me Mumbai","Mumbai Taxi Near Me"]
],



whychoose: [
  {
    WhyChooseheading: "Nearby Cabs Available Across Mumbai",
    WhyChoosedescription: "Omshree Cabs provides quick cab availability across Mumbai including Andheri, Borivali, Bandra, Dadar, Kurla, Thane, and Navi Mumbai. Our nearby drivers ensure fast pickup and convenient travel for local and outstation journeys."
  },
  {
    WhyChooseheading: "Transparent Local Taxi Pricing",
    WhyChoosedescription: "We offer clear and transparent pricing for cab services near you in Mumbai. Customers are informed about per-kilometer rates, minimum fare, and travel packages before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Taxi Service Near You",
    WhyChoosedescription: "Our cab service near you in Mumbai operates 24 hours a day. Whether you need early morning airport transport or late-night travel, Omshree Cabs is always ready to serve."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Cars",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles. All cars are regularly cleaned and sanitized to provide a comfortable and safe ride for passengers."
  },
  {
    WhyChooseheading: "Local & Outstation Travel Options",
    WhyChoosedescription: "Customers can book cabs for local rides within Mumbai or for outstation travel to destinations like Pune, Lonavala, Nashik, Shirdi, and Mahabaleshwar."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium cars suitable for individuals, families, and business travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Mumbai",
    WhyChoosedescription: "We provide doorstep pickup from homes, offices, hotels, railway stations, and airports anywhere in Mumbai so passengers can start their journey without any hassle."
  },
  {
    WhyChooseheading: "Trusted Taxi Service Near Me",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers searching for cab service near them in Mumbai. Our punctual drivers and comfortable vehicles ensure reliable travel every time."
  }
]
};

const faqData = [
  { question: "How can I find a cab service near me in Mumbai?", answer: "You can easily book a nearby taxi through Omshree Cabs by calling or booking online for quick pickup anywhere in Mumbai." },
  { question: "Do you provide local cab services in Mumbai?", answer: "Yes, Omshree Cabs provides local taxi services for travel across Mumbai including airport transfers and city rides." },
  { question: "Is cab service available 24 hours near me?", answer: "Yes, our cab service near you in Mumbai is available 24/7 for local and outstation travel." },
  { question: "Can I book a cab for Mumbai Airport pickup?", answer: "Yes, we provide reliable airport pickup and drop services for Mumbai Airport Terminal 1 and Terminal 2." },
  { question: "Which vehicles are available for booking?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on passenger requirements." },
  { question: "Do you provide outstation cab services from Mumbai?", answer: "Yes, we provide outstation cab services from Mumbai to Pune, Nashik, Surat, Lonavala, and many other destinations." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended during weekends, holidays, and peak travel hours." },
  { question: "Can I stop during the journey?", answer: "Yes, passengers can request short stops for meals, fuel, or refreshment breaks during the trip." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain hygiene and passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ajay Shah",
    feedback:
      "I searched for cab service near me in Mumbai and booked Omshree Cabs. The driver arrived quickly and the ride was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback:
      "Very reliable local taxi service in Mumbai. Easy booking, clean car, and professional driver.",
    rating: 5
  }
];




















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service Near Me Mumbai",
  "description": "Omshree Cab provides reliable cab service near you in Mumbai for local travel, airport transfers, and quick taxi bookings. Find the nearest cabs at affordable fares with easy online booking and trusted taxi service across Mumbai.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3100"
  }
};








  return (
    <div>
      
<Helmet>
  <title>Cab Service Near Me Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab offers cab service near me in Mumbai for local travel, airport transfers, and quick taxi bookings. Affordable fares and easy online booking for the nearest cabs in Mumbai." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/42.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabservicenearmemumbai;